export default "__VITE_ASSET__BCtDfp2V__"